/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const GlobalErrorPageWrapper = styled.div({
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
  color: token('color.text.subtle'),
});

export const Center = styled.div({
  textAlign: 'center',
  width: '320px',
});

export const ErrorImage = styled.div({
  width: '80px',
  margin: 'auto',
});
